import styled, { css } from 'styled-components';
import { Icon, Modal } from 'src/components';
import { hover } from 'src/components/utils';
import { CloseButton } from 'src/components/Modal/styles';

export const overlayTextShadow = css`
  text-shadow: 0 1px 3px hsla(0, 0%, 0%, 0.45);
`;

export const Eyebrow = styled.p(
  ({ theme }) => css`
    ${theme.typography.heading.desktop.xxxs};
    margin: 0;
    color: ${theme.co.neutral40};
    font-size: ${theme.sz.s3};
    letter-spacing: 0.06em;
    text-transform: uppercase;
  `,
);

/** Growth flower above the card label; 5× inline size on desktop, half that on mobile. */
export const HeaderFlower = styled.span(
  ({ theme }) => css`
    display: inline-block;
    flex-shrink: 0;
    overflow: visible;

    svg {
      display: block;
      width: calc(${theme.sz.s7} * 5);
      height: calc(${theme.sz.s7} * 5);
      overflow: visible;
    }

    @media (max-width: ${theme.sz.lg}) {
      svg {
        width: calc(${theme.sz.s7} * 5 / 2);
        height: calc(${theme.sz.s7} * 5 / 2);
      }
    }
  `,
);

export const OptionsModal = styled(Modal)(
  ({ theme }) => css`
    .reactModalContent {
      max-width: ${theme.sz.s};
      padding: ${theme.sz.s6};
    }

    ${CloseButton} {
      top: ${theme.sz.s4};
      right: ${theme.sz.s4};
    }
  `,
);

export const OptionsModalContent = styled.div<{ $inSheet: boolean }>(
  ({ theme, $inSheet }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.sz.s4};
    color: ${theme.co.neutral20};

    ${
      $inSheet
        ? css`
            padding: ${theme.sz.s2} ${theme.sz.s2} 0;
          `
        : css`
            > :first-child {
              padding-inline-end: ${theme.sz.s12};
            }
          `
    }
  `,
);

export const OptionsList = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.sz.s2};
  `,
);

export const OptionButton = styled.button<{ $primary?: boolean }>(
  ({ theme, $primary }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.sz.s3};
    width: 100%;
    padding: ${theme.sz.s3} ${theme.sz.s4};
    border: 0;
    border-radius: ${theme.bo.mediumSmall};
    background-color: ${$primary ? theme.co.primary20 : theme.co.neutral98};
    color: ${theme.co.neutral10};
    text-align: start;
    cursor: pointer;

    &:hover {
      background-color: ${hover($primary ? theme.co.primary20 : theme.co.neutral98)};
    }

    ${theme.focusVisible};
  `,
);

export const OptionIcon = styled(Icon)(
  ({ theme }) => css`
    flex-shrink: 0;
    font-size: ${theme.sz.s5};
  `,
);

export const OptionText = styled.span`
  display: flex;
  flex-direction: column;
`;

export const OptionTitle = styled.span(
  ({ theme }) => css`
    ${theme.typography.heading.desktop.xxxs};
  `,
);

export const OptionDescription = styled.span(
  ({ theme }) => css`
    ${theme.typography.paragraph.s};
    color: ${theme.co.neutral30};
  `,
);
